<template>
    <slot name="trigger" :click="open"></slot>
    <modal v-model="modal" allow-close>
        <template v-slot:header>Delete Article</template>
        <div class="form-group">
            <label>Title</label>
            <input type="text" name="social-title" class="form-control" v-model="title" readonly="readonly">
            <input type="hidden" name="post_id" v-model="id">
        </div>
        <div class="form-group">
            <label>Description</label>
            <textarea class="form-control" v-model="description" readonly="readonly" rows="5"></textarea>
        </div>
        <div class="form-group">
            <label>Article Text</label>
            <textarea class="form-control" v-model="article_text" readonly="readonly" rows="5"></textarea>
        </div>
        <div class="form-group">
            <label>Publish On</label>
            <datepicker class="form-control" v-model="published_on" disabled="disabled"></datepicker>
        </div>
        <template v-slot:footer>
            <div class="d-flex justify-content-end">
                <button @click="modal = !modal" class="btn btn-default mx-2">Cancel</button>
                <button @click="deleteArticle" class="btn btn-primary">Delete Article</button>
            </div>
        </template>
    </modal>
</template>

<script lang="ts">
    import {defineComponent, ref} from "vue";
    import Datepicker from 'vue3-datepicker';
    import Modal from "@/components/modal.vue";
    import {store} from "@/store";
    import {MutationTypes} from "@/store/modules/ux/mutations";
    import {NotificationIcon,NotificationColor} from "@/interfaces/notification";
    import {Article} from "@/models/article";

    export default defineComponent({
        name: "DeleteArticle",
        components: {
            Datepicker,
            Modal
        },
        props:{
            articleObj:{type:Object, required:true},
        },
        emits:['deleteArticleData'],
        setup(props, {emit}){
            const modal = ref(false);
            const open = ()=>modal.value = !modal.value;
            const id = ref(props.articleObj.id);
            const title = ref(props.articleObj.title);
            const description = ref(props.articleObj.description);
            const article_text = ref(props.articleObj.article_text);
            const published_on = ref(new Date(props.articleObj.published_on));

            const deleteArticle = () =>{
                Article.deleteArticle({
                    'id':id.value
                }).then((res)=>{
                    emit('deleteArticleData',res.data);
                    modal.value = false;
                    store.commit(MutationTypes.addSystemNotification,{title:'Success',content:'The article has been Deleted',icon:NotificationIcon.SUCCESS,color:NotificationColor.GREEN});
                });
            }

            return{
                Article,
                article_text,
                deleteArticle,
                description,
                id,
                modal,
                open,
                published_on,
                title,
            }
        }
    });
</script>

<style scoped>

</style>
